/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {CardsWidget20} from '../../../_metronic/partials/widgets'
import {Link} from 'react-router-dom'
import {useAuth} from '../hooks/useAuth'

const PanelPage: FC = () => {
  const {applications} = useAuth()

  return (
    <>
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10 mx-0 mt-0'>
        {applications.length > 0 &&
          applications.map((app: any) => (
            <div
              className='col-md-4 col-lg-4 col-xl-3 col-xxl-3 mb-md-3 mb-xl-6'
              key={app.description}
            >
              <Link to={app.path}>
                <CardsWidget20
                  className='h-md-100 mb-xl-10'
                  description={app.description}
                  color='#EBF0F9'
                  img={toAbsoluteUrl(`${app.img}`)}
                />
              </Link>
            </div>
          ))}
      </div>
    </>
  )
}

const PanelWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={[]}>Panel de Sistemas</PageTitle>
      <PanelPage />
    </>
  )
}

export {PanelWrapper}
